import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setUeItemPage: Mutation<IModuleState> = (state, payload) => {
  state.ueItemPage.data = payload.data;
  state.ueItemPage.total = payload.total;
  state.ueItemPage.pageNum = payload.pageNum;
  state.ueItemPage.pageSize = payload.pageSize;
  state.ueItemPage.loading = !!payload.loading;
};

// 详情
export const setDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

export const setDownloaded: Mutation<IModuleState> = (state, payload) => {
  state.downloaded = payload;
};

export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
